export const quizData = [
  {
    "id": "wibey",
    "gname": "Quiz_wibey",
    "title": "Wibey",
    "questionCount": 2,
    "questions": [
      {
        "id": "wibey-q1",
        "prompt": "What is the best way to describe Wally?",
        "options": [
          {
            "id": "a",
            "text": "A helper that answers your data questions when you ask"
          },
          {
            "id": "b",
            "text": "A digital twin that learns what you want and gets it done on its own"
          },
          {
            "id": "c",
            "text": "A tool that sends you reports on a schedule"
          },
          {
            "id": "d",
            "text": "All of the Above"
          }
        ],
        "correct": "d"
      },
      {
        "id": "wibey-q2",
        "prompt": "What sets WIBEY apart from standard \"vibe coding\" or generic auto-complete models?",
        "options": [
          {
            "id": "a",
            "text": "It only works with basic HTML and CSS files"
          },
          {
            "id": "b",
            "text": "It leverages domain knowledge bases, internal APIs, and governance meta-rules to generate context-aware, production-ready code"
          },
          {
            "id": "c",
            "text": "It requires developers to type full 500-word prompt files for simple bug fixes"
          },
          {
            "id": "d",
            "text": "It only operates on COBOL legacy systems and cannot support modern languages like Java or Go"
          }
        ],
        "correct": "b"
      }
    ]
  },
  {
    "id": "triagent",
    "gname": "Quiz_triagent",
    "title": "RootIQ",
    "questionCount": 3,
    "questions": [
      {
        "id": "triagent-q1",
        "prompt": "Before Walmart's SRE team deployed their autonomous AI system, how long did it typically take engineers to understand the true root cause of a production incident — just to understand it, before any fix begins?",
        "options": [
          {
            "id": "a",
            "text": "About 5 minutes"
          },
          {
            "id": "b",
            "text": "About 15 minutes"
          },
          {
            "id": "c",
            "text": "Close to an hour"
          },
          {
            "id": "d",
            "text": "It varies too much to measure"
          }
        ],
        "correct": "c"
      },
      {
        "id": "triagent-q2",
        "prompt": "What does RootIQ do after resolution that no traditional monitoring tool does?",
        "options": [
          {
            "id": "a",
            "text": "Sends an automated email summary to stakeholders"
          },
          {
            "id": "b",
            "text": "Archives the incident log for compliance"
          },
          {
            "id": "c",
            "text": "Surfaces prescriptive Correction of Errors (COE) insights to fix the conditions that create incidents — not just the incident itself"
          },
          {
            "id": "d",
            "text": "Restarts affected services automatically"
          }
        ],
        "correct": "c"
      },
      {
        "id": "triagent-q3",
        "prompt": "The Accuracy Gap (Engagement + Call to Action) RootIQ achieves ~90% accuracy when given structured inputs like namespace names or incident IDs. But what happens when engineers use informal language — team nicknames, acronyms, and internal shorthand?",
        "options": [
          {
            "id": "a",
            "text": "RootIQ rejects the query and asks for a structured format"
          },
          {
            "id": "b",
            "text": "Accuracy drops to ~45–50%, because tribal knowledge isn't encoded"
          },
          {
            "id": "c",
            "text": "Accuracy stays the same — AI understands context automatically"
          },
          {
            "id": "d",
            "text": "The query is escalated to a human SRE"
          }
        ],
        "correct": "b"
      }
    ]
  },
  {
    "id": "smartyard",
    "gname": "Quiz_smartyard",
    "title": "Smartyard",
    "questionCount": 3,
    "questions": [
      {
        "id": "smartyard-q1",
        "prompt": "Before computer vision, how long could a full manual yard audit take at a large distribution facility?",
        "options": [
          {
            "id": "a",
            "text": "A few hours"
          },
          {
            "id": "b",
            "text": "One full shift"
          },
          {
            "id": "c",
            "text": "Up to several days"
          },
          {
            "id": "d",
            "text": "About 30 minutes"
          }
        ],
        "correct": "c"
      },
      {
        "id": "smartyard-q2",
        "prompt": "What infrastructure powers computer vision's real-time trailer tracking across the yard?",
        "options": [
          {
            "id": "a",
            "text": "GPS trackers attached to every trailer"
          },
          {
            "id": "b",
            "text": "A network of cameras connected to edge compute running computer vision models"
          },
          {
            "id": "c",
            "text": "RFID scanners at gate entry and exit points"
          },
          {
            "id": "d",
            "text": "Manual barcode scanning by yard drivers"
          }
        ],
        "correct": "b"
      },
      {
        "id": "smartyard-q3",
        "prompt": "Trailer Unload Prioritization (TUP) ranks trailers just once when they arrive at the yard and holds that ranking until unload. (True/False)?",
        "options": [
          {
            "id": "a",
            "text": "True"
          },
          {
            "id": "b",
            "text": "False"
          }
        ],
        "correct": "b"
      }
    ]
  },
  {
    "id": "sparky",
    "gname": "Quiz_sparky",
    "title": "Sparky",
    "questionCount": 3,
    "questions": [
      {
        "id": "sparky-q1",
        "prompt": "When Sparky first opens, what does a customer typically see before typing anything?",
        "options": [
          {
            "id": "a",
            "text": "A blank screen"
          },
          {
            "id": "b",
            "text": "Personalized suggestion chips based on their shopping history and behavior"
          },
          {
            "id": "c",
            "text": "A list of product suggestions"
          },
          {
            "id": "d",
            "text": "A list of all Walmart departments"
          }
        ],
        "correct": "b"
      },
      {
        "id": "sparky-q2",
        "prompt": "Can a customer use Sparky for Customer Care-related questions (like order issues)?",
        "options": [
          {
            "id": "a",
            "text": "No, Sparky is shopping-only"
          },
          {
            "id": "b",
            "text": "Only through a separate Customer Care app"
          },
          {
            "id": "c",
            "text": "Yes, Sparky supports Customer Care use cases alongside shopping"
          },
          {
            "id": "d",
            "text": "Only via email"
          }
        ],
        "correct": "c"
      },
      {
        "id": "sparky-q3",
        "prompt": "Can Customers shop products with a hand-written grocery list image using Sparky?",
        "options": [
          {
            "id": "a",
            "text": "Sparky only accepts barcodes in images"
          },
          {
            "id": "b",
            "text": "Sparky only accepts printed text in images"
          },
          {
            "id": "c",
            "text": "Sparky doesn't support image uploads at all"
          },
          {
            "id": "d",
            "text": "Sparky can read a photo of a handwritten grocery list and find matching products"
          }
        ],
        "correct": "d"
      }
    ]
  },
  {
    "id": "wally",
    "gname": "Quiz_wally",
    "title": "Wally",
    "questionCount": 3,
    "questions": [
      {
        "id": "wally-q1",
        "prompt": "What is the best way to describe Wally?",
        "options": [
          {
            "id": "a",
            "text": "A helper that answers your data questions when you ask"
          },
          {
            "id": "b",
            "text": "A digital twin that learns what you want and gets it done on its own"
          },
          {
            "id": "c",
            "text": "A tool that sends you reports on a schedule"
          },
          {
            "id": "d",
            "text": "All of the Above"
          }
        ],
        "correct": "d"
      },
      {
        "id": "wally-q2",
        "prompt": "What makes Wally's analytics different from traditional BI tools?",
        "options": [
          {
            "id": "a",
            "text": "It answers data questions in plain English instead of making you write queries"
          },
          {
            "id": "b",
            "text": "It monitors your metrics and proactively alerts you when something looks off"
          },
          {
            "id": "c",
            "text": "It reasons across multiple datasets in a single conversation to explain why a number moved — and remembers that reasoning as a reusable skill"
          },
          {
            "id": "d",
            "text": "It generates a dashboard or summary on demand from whichever dataset you point it at"
          }
        ],
        "correct": "c"
      },
      {
        "id": "wally-q3",
        "prompt": "What does \"Conversation to Skill\" mean in Wally?",
        "options": [
          {
            "id": "a",
            "text": "Wally saves your chat history so you can scroll back and re-read past answers"
          },
          {
            "id": "b",
            "text": "Wally suggests follow-up questions based on what you asked earlier in the conversation"
          },
          {
            "id": "c",
            "text": "Wally captures the reasoning steps from a conversation and turns them into a reusable skill it can re-run on its own"
          },
          {
            "id": "d",
            "text": "Wally lets you re-run an earlier question with new filters or a different date range"
          }
        ],
        "correct": "c"
      }
    ]
  },
  {
    "id": "shop-fast-exit-faster",
    "gname": "Quiz_shop-fast-exit-faster",
    "title": "Shop fast. Exit faster.",
    "questionCount": 3,
    "questions": [
      {
        "id": "shop-fast-exit-faster-q1",
        "prompt": "By replacing manual receipt checks with these automated exit archways, how much faster do shoppers actually get out of the store?",
        "options": [
          {
            "id": "a",
            "text": "Only about 2% faster, it's mostly just for show."
          },
          {
            "id": "b",
            "text": "It actually takes longer because the machine has to boot up."
          },
          {
            "id": "c",
            "text": "Shoppers breeze through the exit roughly 23% faster."
          }
        ],
        "correct": "c"
      },
      {
        "id": "shop-fast-exit-faster-q2",
        "prompt": "How does the exit archway know that you actually paid for the specific items it sees in your cart?",
        "options": [
          {
            "id": "a",
            "text": "You have to hold a paper receipt up to a glass window."
          },
          {
            "id": "b",
            "text": "The system instantly cross-references the camera images with your digital mobile receipt in the background."
          },
          {
            "id": "c",
            "text": "An employee has to type your membership number into a computer as you walk past."
          }
        ],
        "correct": "b"
      },
      {
        "id": "shop-fast-exit-faster-q3",
        "prompt": "What happens if your items are stacked weirdly, or if a smaller item is hidden underneath a giant box of paper towels?",
        "options": [
          {
            "id": "a",
            "text": "The AI is trained on millions of images and can recognize items from almost any angle or position."
          },
          {
            "id": "b",
            "text": "The system sounds an alarm and locks the exit doors until you restack it perfectly."
          },
          {
            "id": "c",
            "text": "The cameras can only see things sitting perfectly flat on top."
          }
        ],
        "correct": "a"
      }
    ]
  },
  {
    "id": "ai-security",
    "gname": "Quiz_ai-security",
    "title": "AI Security",
    "questionCount": 3,
    "questions": [
      {
        "id": "ai-security-q1",
        "prompt": "At the zone, a model was trained live on two objects held over the tray. It got them both right. Then the same object was held up again, and it called it the other one. What had it actually learned?",
        "options": [
          {
            "id": "a",
            "text": "The visual features of each object, but not enough examples to recognize them consistently"
          },
          {
            "id": "b",
            "text": "The background and the position, not the object at all"
          },
          {
            "id": "c",
            "text": "The relative size and orientation of each object rather than their background"
          },
          {
            "id": "d",
            "text": "A combination of the object's shape and color, but with too much similarity between the two objects"
          }
        ],
        "correct": "b"
      },
      {
        "id": "ai-security-q2",
        "prompt": "Every session at the zone ended the same way. How?",
        "options": [
          {
            "id": "a",
            "text": "With a summary of the three main points"
          },
          {
            "id": "b",
            "text": "With a link to more information"
          },
          {
            "id": "c",
            "text": "With one question, asked and then left unanswered"
          },
          {
            "id": "d",
            "text": "With a prize for whoever did best"
          }
        ],
        "correct": "c"
      },
      {
        "id": "ai-security-q3",
        "prompt": "In the last zone of AI Security, whose device was used for the checks?",
        "options": [
          {
            "id": "a",
            "text": "A tablet provided at the stand"
          },
          {
            "id": "b",
            "text": "A shared laptop on the desk"
          },
          {
            "id": "c",
            "text": "The visitor's own phone, on their own account"
          },
          {
            "id": "d",
            "text": "Whichever was free at the time"
          }
        ],
        "correct": "c"
      }
    ]
  }
];

export default quizData;